<template>
  <div class="index">
    <LoadingModal />
    <div class="top">
      <div>
        <p class="phone" @click="updateMobile">{{ userInfoData.userPhone }}</p>
        <p class="label">欢迎您，{{ userInfoData.userNo }}</p>
      </div>
      <div class="vip"><img :src="topImg" /></div>
    </div>
    <div class="topbutton">
      <div class="left">
        <van-button round style="width: 90px" @click="couponsHandle($event)">可用礼券</van-button>
        <!-- <van-button round class="disable" style="width: 90px;" @click="$push({ path: `/usedCoupons` })">已用礼券</van-button> -->
        <van-button round class="disable" style="width: 90px" @click="usedCouponsHandle($event)">已用礼券</van-button>
        <van-button round class="disable" @click="$push({ path: '/orders?type=-1' })">订单</van-button>
        <van-button round class="disable" @click="$push({ path: '/withdrawList?type=-1' })">提现</van-button>
      </div>
      <!-- <div class="right">
        <div><van-icon class="iconfont iconyonghu1"></van-icon>设置</div>
      </div> -->
    </div>
    <div class="coupons" id="coupons">
      <div class="list" v-for="(item, index) in couponsList" :key="index" :style="item.style"
        @click="clickHandle(item)">
        <!-- black -->
        <div class="right">
          <div class="content" @click="tips(item)">
            <div><i class="iconfont icongantanhao"></i><span>TIPS</span></div>
          </div>
        </div>
        <div class="pageFlexBetween">
          <div class="pageFlexColumnLeft left">
            <p class="title">{{ item.couponsMouldShowName }}{{ item.recoveryStatus == 1 ? '(转让中)' : '' }}</p>
            <p class="num">
              <van-icon name="coupon" size="16" class="coupon-icon" /><span>{{
                item.couponsNum
              }}</span>
            </p>
            <p class="time">
              <span v-if="item.couponsType === 0">
                <i class="iconfont iconu728" />
                <b v-if="item.couponsBalance">{{Number(item.couponsBalance).toFixed(2) }}</b>
                <b v-else>{{$formatMoney(Number(item.couponsBalance), 2)}}</b>
              </span>
              <i class="iconfont icontime" /> {{ item.couponsEndDate }}
            </p>
            <div class="button" v-if="item.couponsType === 0">
              <!-- <van-button
                v-if="item.couponsBuyerId === '992d00548582496db8f8b0426f767deb'"
                round @click="withdraw(item)">快捷提现</van-button> -->
              <van-button round @click="toUse(item)">兑换</van-button>
              <!-- <van-button round v-if="showWeChatRedPacket(item)" @click="toWeChatRedPacket(item)">微信零钱</van-button> -->
            </div>
          </div>
          <div class="qrCode" v-if="item.couponsType === 1">
            <van-icon name="qr" size="35" />
          </div>
        </div>
        <!-- <p class="recovery" v-if="
          item.couponsBuyerId !== '992d00548582496db8f8b0426f767deb' &&
          item.couponsType === 0 &&
          (item.categoryType === 0 || item.categoryType === 1)
        ">
          <a @click="batchHandleNext(item.couponsId)">批量转让卡券</a>
          <a @click="showRecovery(item.couponsId)">查看已转让卡券</a>
        </p> -->
      </div>
      <div class="add">
        <p class="title">暂无更多礼券可用</p>
        <p class="tips">点击添加礼券按钮绑定礼券</p>
        <p class="button">
          <van-button round @click="$push({ path: '/recharge' })">添加礼券</van-button>
        </p>
        <div class="gift"><img :src="lgImg" alt="" /></div>
      </div>
      <!-- <div class="button">
        <van-button
          v-show="couponsList.length > 0"
          class="btn-batch"
          round
          @click="batchHandleNext"
          >批量转让卡券</van-button
        >
        <van-button round @click="showRecovery">查看已转让卡券</van-button>
      </div> -->
    </div>
    <div class="remark">
      <p>
        本服务由"<b>{{
          $getItem("config") != undefined ? $getItem("config").name : ""
        }}</b>"提供
      </p>
      <p v-if="hostList.indexOf(hostname) < 0">
        官方客服热线：<a style="color: #aaa" :href="'tel:' + serverPhone.replace(/[^a-zA-Z0-9]/g, '')">
          {{ serverPhone }}</a>
      </p>
      <p v-if="hostList.indexOf(hostname) < 0">
        工作时间：08:30 - 18:00 节假日：09:00 - 17:00
      </p>
      <div style="display: flex; justify-content: space-between; margin-top: 5px">
        <p style="color: blue" @click="helpHandle">帮助反馈>>></p>
        <van-button v-if="waitPayOrdersCount > 0" round style="box-shadow: #ccc 0 0 5px; height: 30px"
          @click="refundHandle">权益回收</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserInfo, getCoupons, getUserWaitPayOrdersCount } from "api/user";
import { couponRecharge } from "api/submit";
import { transfer_link } from "utils/defaultData";
import { wechatAuth } from "api/auth";
import { Dialog } from 'vant';

import {
  getTransCardUrl,
  getBatchRecoveryUrl,
  getServerPhone,
  getRecoveryHomeUrl,
  getDrivingCodeUrl,
} from "api/onLine";
import { getRedistributionConditionsApi } from "api/user";
// /*global $ */
export default {
  data() {
    return {
      hostList: ["zyb.tongdaogu.cn"],
      lgImg: require("assets/gift.png"),
      topImg: require("assets/u602.png"),
      userInfoData: {
        balance: 0,
        coupons_count: 0,
        userNickName: "",
      },
      oldName: 0,
      loadingText: "暂无相关卡券",
      showAlert: false,
      selectStatus: "",
      list: [
        {
          name: "可用券",
          status: 0,
        },
        {
          name: "已使用",
          status: 1,
        },
        {
          name: "已过期",
          status: 2,
        },
      ],
      couponsList: [],
      count: 0,
      show: false,
      recordShow: false,
      ctitle: "",
      ccode: "",
      isDelete: false,
      link: transfer_link,
      transferLink: "",
      showGet: false,
      isShow: false,
      showContent: false,
      dialogShow: false,
      old: 0,
      appid: "",
      showLoading: true,
      showRemark: false,
      badge: "",
      result: true,
      show_link: false,
      recordList: [],
      authCount: 0,
      firstOnLoad: true,
      serverPhone: "",
      configModel: "",
      hostname: "",
      couponsId: "",
      couponsUpstreamId: "",
      couponsBuyerUserId: "",
      waitPayOrdersCount: 0,
      redistributionConditions: undefined,
    };
  },
  created() {
    this.hostname = location.hostname;
  },
  async mounted() {
    this.auth();
    this.couponsHandle();
    this.getWaitPayOrdersCount();
  },
  methods: {
    toWeChatRedPacket(row) {
      let hrefStr =
        "/onLineIndex" +
        "?ident=weChatPoints" +
        "&name=微信零钱" +
        "&categoryId=e1580ea82479420b81a8ba223b647ba5" +
        "&mouldId=" + row.couponsMouldId +
        "&upstreamId=" + row.couponsUpstreamId +
        "&buyerUserId=" + row.couponsBuyerUserId +
        '&couponId=' + row.couponsId;

      location.href = hrefStr
    },
    async getRedistributionConditions(){
      await getRedistributionConditionsApi()
      .then(({status, data}) => {
        if(status == 200){
          this.redistributionConditions = data;
        }
      })
    },
    showWeChatRedPacket: function(coupon) {
      if (!coupon?.couponsCategory?.includes("weChatPoints")) {
        return false
      }
      return true
    },
    getServerPhone() {
      getServerPhone().then((res) => {
        if (res.status == 200) {
          this.serverPhone = res.data;
        } else {
          this.$error(res.message);
        }
      });
    },
    getWaitPayOrdersCount() {
      getUserWaitPayOrdersCount().then((res) => {
        if (res.status == 200) {
          this.waitPayOrdersCount = res.data;
        } else {
          this.$error(res.message);
        }
      });
    },
    handleNext(val) {
      getTransCardUrl(val).then((res) => {
        if (res.status == 200) {
          if ((res.data != "") & (res.data != null)) {
            location.href = res.data;
          }
        } else {
          this.$error(res.message);
        }
      });
    },
    batchHandleNext(val) {
      // if (this.couponsList.length < 1) {
      //   this.$error("当前没有可转让的券");
      //   return;
      // }
      getBatchRecoveryUrl(val).then((res) => {
        if (res.status == 200) {
          if ((res.data != "") & (res.data != null)) {
            location.href = res.data;
          }
        } else {
          this.$error(res.message);
        }
      });
    },
    toUse(item) {
      if (item.couponsMouldId == "2a83e8ac78ab408f8ce41851847d2f7b") {
        location.href = "https://m.cmbbao.com/zt/20210817_haoli/";
      } else {
        this.$push({
          path: "/index",
          query: {
            count: this.couponsList.length,
            id: item.couponsId,
            couponsMouldId: item.couponsMouldId,
            couponsUpstreamId: item.couponsUpstreamId,
            couponsBuyerUserId: item.couponsBuyerUserId,
          },
        });
      }
      this.couponsId = item.couponsId;
      this.couponsUpstreamId = item.couponsUpstreamId;
      this.couponsBuyerUserId = item.couponsBuyerUserId;
    },
    async tips(item) {
      if(this.redistributionConditions == undefined){
        await this.getRedistributionConditions();
      }
      if(item.couponsBalance < this.redistributionConditions){
        this.$alert(item.couponsProductName);
      }else{
        Dialog.confirm({
          title: item.couponsProductName,
          confirmButtonText: '确认',
          cancelButtonText: '分发'
        })
        .then(() => {})
        .catch(() => {
          this.$push({ path: '/distribute?couponsId=' + item.couponsId })
        });
      }
    },
    auth() {
      let isAuth = this.$getItem("isAuth");
      let code = this.$route.query.code;
      let state = this.$route.query.state;

      if (isAuth == undefined || code != undefined) {
        wechatAuth(code, state).then((res) => {
          this.authCount = 1;
          if (res.status == 200) {
            this.$setItem("isAuth", 1);
            this.getUserInfo();
          } else {
            this.$error(res.message);
          }
        });
      } else {
        this.getUserInfo();
      }
    },
    getUserInfo() {
      var that = this;
      let code = this.$route.query.code;
      let state = this.$route.query.state;
      getUserInfo().then((res) => {
        if (res.status == 200) {
          that.userInfoData = res.data;
          if (that.userInfoData.userPhone != undefined) {
            this.$setItem("userModel", res.data);
            this.getlist(0);
          } else {
            that.$push({
              path: "/register",
            });
          }
          this.getServerPhone();
        } else if (res.status == 400) {
          if (that.firstOnLoad) {
            that.firstOnLoad = false;
            wechatAuth(code, state).then((res) => {
              this.authCount = 1;
              if (res.status == 200) {
                this.$setItem("isAuth", 1);
                this.getUserInfo();
              }
            });
          }
        } else {
          if (this.authCount < 1) {
            this.$removeItem("isAuth");
            this.auth;
          }
          this.$error(res.message);
        }
      });
    },
    goUse(model) {
      this.$push({
        path: "/" + model.go_to,
        query: {
          servicename: model.go_to,
        },
      });
      // :to="'/medical?servicename='+item.go_to+(item.go_to=='cytj'?'&cardid='+item.card_id:'')"
    },
    tourl() {
      location.href = this.url;
    },
    jumpOld() {
      this.dialogShow = true;
    },
    hideDialog() {
      this.showAlert = false;
    },
    Recharge(card_id, is_can_use) {
      this.$confirm("确认要充值到账户吗？", "确认提示")
        .then(() => {
          this.Recharges(card_id, is_can_use);
        })
        .catch(() => {
          // on cancel
        });
    },
    Recharges(card_id, is_can_use) {
      if (is_can_use == 0) {
        this.$error("此卡已被锁定");
        return;
      }
      couponRecharge(card_id).then((res) => {
        switch (res.status) {
          case 1:
            this.$successSync("充值成功", () => {
              this.$push({
                path: "/user",
              });
            });
            break;
          case 9107:
            this.$alert("请进行实名认证").then(() => {
              // this.$push({
              //   path: "/certification"
              // });
            });
            break;
          default:
            this.$error(res.message);
            break;
        }
      });
    },
    onClick(name) {
      if (this.oldName === name) {
        return false;
      }
      this.showLoading = true;
      this.showRemark = false;
      this.oldName = name;
      this.couponsList = [];
      this._getCouponsList(name);
    },
    showPopup(
      cid,
      title,
      count,
      type,
      carNo,
      serviceName,
      status,
      issuer_name,
      expire_date,
      ctiy_level,
      class_id,
      can_service_id,
      level,
      is_qrcode
    ) {
      if (type == 2 && status === 1 && is_qrcode != 0) {
        this.$push({
          path: "/qrcode",
          query: {
            id: cid,
            ctitle: title,
            ccode: cid,
            car_no: carNo,
            service_name: serviceName,
            issuer_name: issuer_name,
            expire_date: expire_date,
            ctiy_level: ctiy_level,
            class_id: class_id,
            can_service_id: can_service_id,
            level: level,
          },
        });
      }
    },
    _getCouponsList(status) {
      // console.log(this.selectStatus + "当前", status);
      if (this.selectStatus != status) {
        this.selectStatus = status;
        this.loadingText = "加载中...";
        if (this.result) {
          // this.result = false;
          // console.log(status);
          this.getlist(status);
        }
      }
    },
    getlist(status) {
      setTimeout(() => {
        // getCoupons(status, status === "overdue" ? 1 : 0).then((res) => {
        getCoupons(status).then((res) => {
          // $(".footer").show();
          // if (this.selectStatus == status) {
          if (res.status === 200) {
            // this.show_link = res.data.show_link == 1 ? true : false;
            if (
              res.data != undefined &&
              res.data != null &&
              res.data.records.length > 0
            ) {
              this.couponsList = res.data.records;
              this.couponsList.forEach((coupons) => {
                if (coupons.kbPhotoUrl) {
                  coupons.style =
                    "background: url(/api/v1.0/platform/tenant/kb/loading/" +
                    coupons.kbPhotoUrl +
                    ")";
                } else if (coupons.couponsType === 1) {
                  coupons.style = "background: #5599FF";
                } else {
                  coupons.style = "";
                }
                return coupons;
              });
            } else {
              this.couponsList = [];
            }
            if (status == 0) {
              this.userInfoData.coupons_count = res.data.records.length;
            }
            this.showRemark = res.data.records.length <= 0 ? true : false;
          } else {
            this.$error(res.message);
          }
          this.result = true;
          this.showLoading = false;
          this.$nextTick(() => {
            this.$store.commit("setPageLoading", false);
          });
          // }
        });
      }, 500);
    },
    couponsHandle(event) {
      if (!event) {
        return;
      }
      if (!event.target.nextSibling.classList.contains("disable")) {
        event.target.nextSibling.classList.add("disable");
        event.target.classList.toggle("disable");
      }
    },
    usedCouponsHandle(event) {
      if (!event.target.previousSibling.classList.contains("disable")) {
        event.target.previousSibling.classList.add("disable");
        event.target.classList.toggle("disable");
        this.$push({
          path: `/usedCoupons`,
          query: {
            userPhone: this.userInfoData.userPhone,
            userNo: this.userInfoData.userNo,
            count: this.couponsList.length,
            id: this.couponsId,
            couponsMouldId: this.couponsMouldId,
            couponsUpstreamId: this.couponsUpstreamId,
            couponsBuyerUserId: this.couponsBuyerUserId,
          },
        });
      }
    },
    showRecovery(val) {
      getRecoveryHomeUrl(val).then((res) => {
        if (res.status == 200) {
          if ((res.data != "") & (res.data != null)) {
            location.href = res.data;
          }
        } else {
          this.$error(res.message);
        }
      });
    },
    async updateMobile() {
      this.$push({
        path: "/updateMobile",
        query: { phone: this.userInfoData.userPhone },
      });
    },
    helpHandle() {
      this.$push({
        path: "/help",
      });
    },
    refundHandle() {
      this.$push({
        path: "/refunds",
      });
    },
    clickHandle(coupons) {
      if (coupons.couponsType === 0) {
        return;
      }
      if (coupons.couponsCategory === "carWashing") {
        this.$push({
          path: "/showQRCode",
          query: {
            couponInfo: JSON.stringify(coupons),
          },
        });
      }
      if (coupons.couponsCategory === "driving") {
        getDrivingCodeUrl(coupons.couponsPwNo).then((res) => {
          if (res.status == 200) {
            window.location.href(res.data.url);
          } else {
            this.$error(res.message);
          }
        });
      }
    },
    withdraw(row) {
      console.log(row)
      this.$store.commit('setCoupon', row)
      this.$push({ name: "Withdraw" });
    },
  },
};
</script>

<style lang="less" scoped>
.index {
  margin: 10px;

  .top {
    background: linear-gradient(90deg, #f0bc2d, #d9cb00);
    color: #2e2809;
    padding: -20px;
    margin: -20px;
    height: 130px;

    div {
      padding: 30px 20px 20px 20px;

      .phone {
        color: #2e2809;
      }

      .label {
        font-weight: 700;
        font-size: 22px;
        width: 65%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }

    .vip {
      font-size: 80px;
      font-weight: bold;
      color: #666;
      margin-top: -130px;
      text-align: right;
    }
  }

  .topbutton {
    display: flex;
    justify-content: space-between;
    margin-top: 3px;

    .left {
      overflow-x: scroll;
      white-space: nowrap;
      .disable {
        color: #ccc;
      }
    }

    .van-button {
      height: 30px;
      margin-right: 10px;
      font-weight: bold;
      color: #f7b603;
      box-shadow: #3232332e 0 0 15px;
    }
    /deep/ .van-button--normal {
      padding: 0 10px;
    }

    .right {
      background: #fff;
      padding: 5px 10px;
      border-radius: 20px;
      box-shadow: #3232332e 0 0 15px;

      div {
        display: flex;
        align-items: center;

        i {
          font-size: 18px;
          margin-right: 5px;
          font-weight: bold;
          border-radius: 50%;
          color: red;
        }
      }
    }
  }

  .coupons {
    margin: -10px -20px -20px -20px;
    background: #fff;
    padding: 30px 20px 15px 20px;

    .list {
      border-radius: 10px;
      padding: 20px;
      background: #ffbb00;
      color: #fff;
      margin-bottom: 20px;
      position: relative;

      .left {
        .title {
          font-size: 18px;
        }

        .num {
          margin-top: 5px;
          font-size: 16px;

          .coupon-icon {
            position: absolute;
          }

          span {
            margin-left: 20px;
          }
        }

        .time {
          font-size: 12px;
          color: #fff;
          margin-top: 5px;
          display: flex;
          align-items: center;

          span {
            color: #74590f;
            font-size: 18px;
            margin-right: 10px;

            i {
              font-size: 18px;
              font-weight: initial;
            }
          }

          .icontime {
            margin-right: 5px;
          }
        }

        .button {
          margin-top: 15px;
          display: flex;
          justify-content: left;
          align-items: center;

          .van-button {
            box-shadow: #3232332e 0 0 15px;
            height: 30px;
            margin-right: 10px;
            color: #000;
          }

          a {
            color: #fff;
            font-size: 14px;
          }
        }
      }

      .recovery {
        margin-top: 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        a {
          color: #fff;
          font-size: 14px;
          font-weight: bold;
        }
      }

      .black {
        .title {
          color: #000 !important;
        }

        .time {
          span {
            color: #000 !important;
          }
        }

        a {
          color: #000 !important;
        }
      }

      .right {
        position: absolute;
        top: 0;
        right: 0;

        .content {
          display: flex;
          justify-content: flex-end;

          div {
            font-size: 12px;
            opacity: 0.1;
            width: 45px;
            background: #000;
            padding: 5px 10px;
            border-radius: 0 10px 0px 10px;
          }

          i {
            margin-right: 3px;
            font-size: 12px;
          }
        }
      }

      .qrCode {
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
    }

    .add {
      background: initial;
      border: dashed 1px #ccc;
      color: #aaaaaa;
      height: 100px;
      border-radius: 10px;
      padding: 20px;
      margin-bottom: 20px;
      position: relative;

      .title {
        font-size: 18px;
      }

      .tips {
        margin-top: 5px;
        font-size: 12px;
        color: #aaaaaa;
      }

      .button {
        margin-top: 15px;
        display: flex;
        justify-content: left;
        align-items: center;

        .van-button {
          box-shadow: #ccc 0 0 5px;
          color: #d9001b;
          font-weight: bold;
        }
      }

      .gift {
        position: absolute;
        bottom: 20px;
        right: 30px;

        img {
          width: 80px;
        }
      }
    }

    .button {
      margin-top: 20px;
      text-align: right;

      .van-button {
        height: 30px;
        color: #aaaaaa;
      }

      .btn-batch {
        margin-right: 20px;
      }
    }
  }

  .remark {
    margin-top: 30px;
    font-size: 14px;
    color: #aaa;
  }
}
</style>
